import z from 'zod';
import { DeepPartial, Draft } from '../../common';
import { IFieldErrors, ValidationError } from '../../validation';
import { IAppForm, getSchema as getAppSchema } from './appFormSchema';
import { IDI, getSchema as getDISchema } from '../di/diSchema';
import { getSchema as getOrgSchema } from '../orgSchema';
import { IOrgModel } from '../orgInterface';
import { IRequestMeta } from '../request';

export interface IData {
  org?: DeepPartial<IOrgModel>;
  // di?: DeepPartial<IDI>;
  di?: IDI;
  // appForm?:DeepPartial<IAppForm>;
  appForm?: IAppForm;
}

export const getSchema = (update: Draft<DeepPartial<IData>>, type: string, initial?: DeepPartial<IData>) => {
  const { di, org, appForm } = update || {};
  const diSchema = getDISchema(di || {}, type, initial?.di || {});
  const orgSchema = getOrgSchema(org || {}, type);
  const appFormSchema = getAppSchema(
    appForm || {},
    type,
    initial?.di || {},
    di?.satEligibilityInd,
    di?.apEligibilityInd,
  );

  return z.object({ org: orgSchema }).extend({ di: diSchema }).extend({ appForm: appFormSchema });
};

export const validate = (
  update: Draft<IData>,
  type: string,
  meta?: Partial<IRequestMeta>,
  original?: Partial<IData>,
) => {
  const schema = getSchema(update, type, original);

  try {
    // Ensure there are changes from the original record
    return schema.parse(update);
  } catch (error: any) {
    // console.log('DI Data ZOD Error : ', error);
    if (error instanceof z.ZodError) {
      const errors: IFieldErrors = error.format();
      throw new ValidationError(errors);
    }
    throw new Error(error?.message || '');
  }
};
